import { FC, ReactElement, useState, Fragment } from 'react';
import {
    IconButton,
    Box,
    MenuItem,
    Avatar,
    Popper,
    Grow,
    Paper,
    MenuList,
    ClickAwayListener,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { AuthComponentProps, withAuthProvider } from '../../hoc/auth/AuthProvider';
import { DeloitteButton } from '../Deloitte';
import { FabLoader } from '../FabLoader';
import { useHistory } from 'react-router-dom';
import { AuthenticatedUser } from 'TaxAnalyticsState/userState';

const useStyles = makeStyles((theme) => ({
    avatar: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.main,
    }
}));

export interface IUserAvatar {
    user: AuthenticatedUser;
    onClick: (event: any) => void;
}

export const UserAvatar: FC<IUserAvatar> = (props: IUserAvatar): ReactElement => {
    const classes = useStyles();
    const { user, onClick } = props;
    return (
        <Fragment>
            {
                user &&
                <FabLoader loading={user.authenticating}>
                    <IconButton aria-label="login" onClick={onClick} size="large">
                        <Avatar className={classes.avatar}>{user.initials ?? "  "}</Avatar>
                    </IconButton>
                </FabLoader>
            }
        </Fragment>
    );
}


const UserMenuNoAuth: FC<AuthComponentProps> = (props: AuthComponentProps): ReactElement => {
    const history = useHistory();
    const { login, logout, user } = props;
    const [anchorAuthEl, setAuthAnchorEl] = useState<null | HTMLElement>(null);
    const isAuthMenuOpen = Boolean(anchorAuthEl);
    const authMenuId = 'auth-menu';
    const handleAuthMenuOpen = (event: any) => {
        setAuthAnchorEl(event.currentTarget);
    };
    const handleAuthMenuClose = () => {
        setAuthAnchorEl(null);
    };
    const renderPopperMenu = (
        <Popper open={isAuthMenuOpen} anchorEl={anchorAuthEl} role={undefined} placement="bottom" style={{ zIndex: 2000 }}
            transition
            modifiers={[]}>
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                    <Paper>
                        <ClickAwayListener onClickAway={handleAuthMenuClose}>
                            <MenuList autoFocusItem={isAuthMenuOpen} id="menu-list-grow">
                                {user && user.isAuthenticated &&
                                    [
                                        <MenuItem onClick={() => { handleAuthMenuClose(); history.push('/workspace/dashboard'); }} key="1">Mon espace</MenuItem>,
                                        <MenuItem onClick={() => { handleAuthMenuClose(); logout("/"); }} key="2">Se deconnecter</MenuItem>
                                    ]
                                }
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    )

    return (
        <Box>
            {
                (!user || (!user.isAuthenticated && !user.authenticating)) &&
                <DeloitteButton
                    variant="contained" color="primary"
                    size="large"
                    onClick={() => login("/workspace")}
                    aria-controls={authMenuId}
                    aria-haspopup="true">
                    Connexion
                </DeloitteButton>
            }
            {
                user && (user.authenticating || user.isAuthenticated) &&
                <UserAvatar user={user} onClick={handleAuthMenuOpen} />
            }
            {renderPopperMenu}
        </Box>
    )
};

export const UserMenu = withAuthProvider(UserMenuNoAuth, false);